class PopularProductsFilter {
  constructor() {
    this.filterButtons = document.querySelectorAll('.filter-button');
    this.productItems = document.querySelectorAll('.popular-products__item');
    
    if (this.filterButtons.length === 0) return;

    this.bindEvents();
  }

  bindEvents() {
    this.filterButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        const filterValue = button.getAttribute('data-filter');
        this.filterProducts(filterValue);
        this.updateActiveButton(button);
      });
    });
  }

  filterProducts(filterValue) {
    this.productItems.forEach(item => {
      if (filterValue === 'all') {
        item.classList.remove('hidden');
        setTimeout(() => {
          item.style.opacity = '1';
        }, 10);
      } else {
        const tags = item.getAttribute('data-tags') || '';
        if (tags.toLowerCase().includes(filterValue.toLowerCase())) {
          item.classList.remove('hidden');
          setTimeout(() => {
            item.style.opacity = '1';
          }, 10);
        } else {
          item.style.opacity = '0';
          setTimeout(() => {
            item.classList.add('hidden');
          }, 300);
        }
      }
    });
  }

  updateActiveButton(activeButton) {
    this.filterButtons.forEach(button => {
      button.classList.remove('active');
    });
    activeButton.classList.add('active');
  }
}

// Initialize filter on page load
document.addEventListener('DOMContentLoaded', () => {
  new PopularProductsFilter();
});

